import axios from 'axios';

const api = axios.create({
  baseURL: 'https://licenses-api.agrosuit.com',
  // baseURL: 'http://localhost:3334',
});

export default api;
